import { store } from '../../../app/store';
import {
  RealizedPNLPoint,
  selectBalance,
  selectInitialDate,
  selectMaxDate,
  selectPositionHistory,
  selectSymbol,
  SessionStatistics,
  setSessionStatistic,
} from '../../../features/mainSlice/mainSlice';

export function calculateSessionStatistic(): SessionStatistics {
  const positions = selectPositionHistory(store.getState());
  const initialBalance = selectBalance(store.getState());
  const initialDate = selectInitialDate(store.getState());
  const maxDate = selectMaxDate(store.getState());
  const asset = selectSymbol(store.getState());

  const duration = maxDate - initialDate;

  if (positions.length === 0) {
    const emptyStats: SessionStatistics = {
      avgTrade: 0,
      totalTrades: 0,
      bestTrade: 0,
      worstTrade: 0,
      winRate: 0,
      duration: duration,
      totalPNL: 0,
      totalPNLPercent: 0,
      equityTimeline: [{ time: initialDate, equity: initialBalance } as RealizedPNLPoint],
      selectedAsset: asset,
    } as SessionStatistics;
    store.dispatch(setSessionStatistic(emptyStats));

    return emptyStats;
  }

  let equityOverTime = initialBalance;
  let bestTrade = positions[0].pl;
  let worstTrade = positions[0].pl;
  const totalTrades = positions.length;
  let totalPNL = 0;
  const equityTimeline = [];

  let win = 0;
  let lose = 0;

  equityTimeline.push({ time: initialDate, equity: equityOverTime } as RealizedPNLPoint);

  for (const position of positions) {
    totalPNL += position.pl;

    if (position.pl >= 0) win++;

    if (position.pl < 0) lose++;

    bestTrade = Math.max(bestTrade, position.pl);
    worstTrade = Math.min(worstTrade, position.pl);

    equityOverTime += position.pl;
    equityTimeline.push({ time: position.closeTime, equity: equityOverTime } as RealizedPNLPoint);
  }

  equityTimeline.push({ time: maxDate, equity: equityOverTime } as RealizedPNLPoint);
  const winRate = win / (win + lose);
  const totalPNLPercent = totalPNL / initialBalance;
  const avgTrade = totalPNL / totalTrades;

  const stats: SessionStatistics = {
    avgTrade: avgTrade,
    totalTrades: totalTrades,
    bestTrade: bestTrade,
    worstTrade: worstTrade,
    winRate: winRate,
    duration: duration,
    totalPNL: totalPNL,
    totalPNLPercent: totalPNLPercent,
    equityTimeline: equityTimeline as RealizedPNLPoint[],
    selectedAsset: asset,
  } as SessionStatistics;

  store.dispatch(setSessionStatistic(stats));

  return stats;
}
